<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite klienta {{ client.name }}:
    </h2>

    <CompanyClientForm
      @save="save"
      @cancel="cancel"
      :countryList="countryList"
      :client="client"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import CompanyClientForm from '@/components/CompanyClientForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    CompanyClientForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      countryList: []
    }
  },
  computed: {
    client () {
      return this.$store.state.clients.items[this.id]
    }
  },
  methods: {
    ...mapActions('clients', ['loadItem', 'saveItem']),
    ...mapActions('companies', ['getCountries']),
    save ({ data }) {
      saveItem(data, 'MyCompanyClients', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyClients' })
    }
  },
  created () {
    Promise.all([
      this.getCountries(),
      this.loadItem(this.id)
    ])
      .then(response => {
        this.countryList = response[0]
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
